import { defineComponent as I, computed as k, openBlock as s, createElementBlock as v, normalizeClass as X, unref as e, createVNode as l, Transition as _, withCtx as c, renderSlot as q, h as K, useCssVars as j, useTemplateRef as A, ref as L, watch as G, nextTick as J, createBlock as y, normalizeStyle as Q, toDisplayString as C, createElementVNode as b, createCommentVNode as g, createTextVNode as Y } from "vue";
import { s as Z, a as ee, p as te, u as oe, b as ie, R as ae, X as le, c as se, o as N, h as ne, I as V, _ as re } from "../review.es.js";
import { M as S, P as ce, V as de, R as ue, a as ge, u as ve } from "./useTailwindTheme.DdEf1aXL.js";
import { r as pe, V as o, F as fe, N as we } from "./floating.types.Bns6nQ3E.js";
const me = /* @__PURE__ */ I({
  __name: "FloatingBox",
  props: {
    position: {}
  },
  setup(p) {
    const f = pe(p.position), t = k(() => {
      switch (f.value) {
        case "UL":
        case "UR":
          return "slide-down";
        case "CL":
          return "slide-right";
        case "CR":
          return "slide-left";
        default:
          return "slide-up";
      }
    });
    return (w, n) => (s(), v("div", {
      class: X([
        "widget",
        `widget--${e(f)}`
      ]),
      "data-testid": "widget"
    }, [
      l(_, {
        name: t.value,
        appear: ""
      }, {
        default: c(() => [
          q(w.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["name"])
    ], 2));
  }
}), he = /* @__PURE__ */ Z(me, [["__scopeId", "data-v-6ec2e81b"]]), xe = (p, f) => {
  const t = "http://www.w3.org/2000/svg", n = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M4.47 6.97a.75.75 0 011.06 0L10 11.44l4.47-4.47a.75.75 0 111.06 1.06l-5 5a.75.75 0 01-1.06 0l-5-5a.75.75 0 010-1.06z" clip-rule="evenodd"/>
</svg>
`, "image/svg+xml").firstChild;
  if (p.title) {
    const i = document.createElementNS(t, "title");
    i.textContent = p.title, n.appendChild(i);
  }
  const x = Array.from((n == null ? void 0 : n.attributes) ?? []).reduce((i, d) => ({
    ...i,
    [d.name]: d.value
  }));
  return K(
    "svg",
    {
      ...x,
      ...f.attrs,
      role: "img",
      innerHTML: n.innerHTML
    }
  );
}, Ee = { key: 0 }, ye = ["aria-label"], Ce = {
  key: 0,
  class: "py-3 px-4"
}, be = { class: "text-base" }, ke = { class: "text-grey-500" }, De = { class: "flex items-center p-3 gap-4 order-first reviews-header" }, O = 38, $ = 40, Ae = /* @__PURE__ */ I({
  __name: "FloatingDesktopReview",
  props: {
    config: {}
  },
  setup(p, { expose: f }) {
    j((D) => ({
      "0e871bd2": t.config.zIndex,
      "95b08f40": e(d).fontColor,
      "32955b2c": T.value.width,
      "06471081": T.value.height,
      42188316: `${$}px`,
      c2759874: e(d).actionColor.base,
      "82e4ffaa": e(d).backgroundColor.washed
    }));
    const t = p, w = A("rootEl"), n = A("titleEl"), x = A("reviewsEl"), i = L(
      t.config.showClosed ? o.COLLAPSED : o.EXPANDED
    ), d = ee(), { t: m } = te(), P = L(), { height: B } = oe(), {
      height: M
    } = ie(P), E = ve(), F = ae(t.config.isRightAlign), { clear: h } = le({
      enabled: !t.config.showClosed,
      delay: t.config.closeTime,
      callback() {
        i.value = o.COLLAPSED;
      }
    }), { focused: H } = se(n), R = k(() => ({
      [o.COLLAPSED]: {
        width: "240px",
        height: "52px"
      },
      [o.EXPANDED]: {
        width: "220px",
        height: `${O + M.value}px`
      },
      [o.REVIEWS]: {
        width: "520px",
        height: `${Math.min(620, B.value - $)}px`
      }
    })), u = L(!t.config.showSummarized), T = k(() => R.value[i.value]), W = k(() => t.config.devicePosition === "UL" || t.config.devicePosition === "UR" ? "bottom" : "top");
    function U() {
      h(), i.value = i.value === o.EXPANDED ? o.COLLAPSED : o.EXPANDED;
    }
    function z() {
      h(), i.value = o.COLLAPSED;
    }
    return G(
      i,
      async (D) => {
        var a, r;
        await J(), D === o.REVIEWS && ((r = (a = x.value) == null ? void 0 : a.querySelector("button")) == null || r.focus());
      }
    ), N("Escape", z, { target: w }), N(["Enter", "Space", "Tab"], () => {
      h();
    }, { target: w }), f({
      collapse: z
    }), (D, a) => (s(), y(e(he), {
      ref_key: "rootEl",
      ref: w,
      role: "region",
      "aria-label": e(m)("Review Summary"),
      position: t.config.devicePosition,
      class: "floating-review",
      onMouseenter: e(h)
    }, {
      default: c(() => [
        l(e(ne), { class: "floating-review__window" }, {
          default: c(() => [
            i.value === e(o).EXPANDED || i.value === e(o).COLLAPSED ? (s(), v("div", Ee, [
              l(e(fe), {
                open: i.value !== e(o).COLLAPSED,
                position: W.value,
                onClick: U,
                style: Q({
                  height: i.value === e(o).COLLAPSED ? R.value[e(o).COLLAPSED].height : `${O}px`
                }),
                "data-testid": "floatingTrigger"
              }, {
                default: c(() => [
                  l(_, {
                    name: "fade",
                    mode: "out-in",
                    onAfterEnter: a[0] || (a[0] = () => {
                      i.value === e(o).EXPANDED && (H.value = !0);
                    })
                  }, {
                    default: c(() => [
                      i.value === e(o).COLLAPSED ? (s(), y(S, {
                        key: 0,
                        data: t.config.payload.reviewAverages,
                        colors: {
                          darkText: e(d).mainColor.contrasted,
                          lightText: e(d).mainColor.contrasted
                        },
                        "text-style": {
                          score: {
                            size: "16px",
                            weight: "600"
                          },
                          average: {
                            size: "24px",
                            weight: "600"
                          },
                          note: {
                            size: "14px",
                            weight: "600"
                          },
                          based: {
                            size: "12px",
                            weight: "400"
                          }
                        },
                        tooltip: {
                          ...t.config.calculate.tooltip,
                          placement: "top"
                        },
                        "compact-size": "big",
                        "data-testid": "mainRatingCollapsed"
                      }, null, 8, ["data", "colors", "tooltip"])) : (s(), v("h1", {
                        key: 1,
                        ref_key: "titleEl",
                        ref: n,
                        tabindex: "-1",
                        class: "font-semibold text-s leading-4 text-left"
                      }, C(e(m)("Review Summary")), 513))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["open", "position", "style"]),
              i.value === e(o).EXPANDED ? (s(), v("div", {
                key: 0,
                ref_key: "expandedBodyElement",
                ref: P,
                "data-testid": "expandedBody"
              }, [
                b("div", {
                  class: X([
                    "pt-3 px-4",
                    { "pb-4": u.value },
                    { "cursor-pointer": !u.value },
                    { "border-b border-b-grey-100": i.value === e(o).EXPANDED }
                  ]),
                  onClick: a[2] || (a[2] = () => {
                    u.value || (u.value = !0);
                  })
                }, [
                  l(S, {
                    data: t.config.payload.reviewAverages,
                    colors: {
                      darkText: e(E).colors.grey[900],
                      lightText: e(E).colors.grey[500]
                    },
                    tooltip: {
                      ...t.config.calculate.tooltip,
                      placement: "top"
                    },
                    orientation: "vertical"
                  }, null, 8, ["data", "colors", "tooltip"]),
                  t.config.calculate.rankingConfig.visible ? (s(), y(ce, {
                    key: 0,
                    config: t.config.calculate.rankingConfig,
                    inline: "",
                    class: "mt-2"
                  }, null, 8, ["config"])) : g("", !0),
                  u.value ? g("", !0) : (s(), v("button", {
                    key: 1,
                    type: "button",
                    onClick: a[1] || (a[1] = (r) => u.value = !0),
                    "aria-label": e(m)("Show Reviewers"),
                    class: "w-full mt-2 border-0 outline-none text-grey-500 hover:text-grey-900 transition-colors duration-300"
                  }, [
                    l(e(xe), {
                      "aria-label": e(m)("Arrow icon"),
                      class: "w-4 h-4 mx-auto"
                    }, null, 8, ["aria-label"])
                  ], 8, ye))
                ], 2),
                u.value ? (s(), v("div", Ce, [
                  l(e(de), {
                    items: t.config.calculate.providers,
                    direction: "column",
                    class: "mb-4 leading-6"
                  }, {
                    value: c(({ item: r }) => [
                      b("strong", be, C(r.value.score), 1),
                      b("span", ke, "/" + C(r.value.max), 1)
                    ]),
                    _: 1
                  }, 8, ["items"]),
                  t.config.showReviews ? (s(), y(e(we), {
                    key: 0,
                    ref: "reviewsBtn",
                    onClick: a[3] || (a[3] = (r) => {
                      i.value = e(o).REVIEWS, e(h)();
                    }),
                    class: "text-sm"
                  }, {
                    default: c(() => [
                      Y(C(e(m)("Read Reviews")), 1)
                    ]),
                    _: 1
                  }, 512)) : g("", !0)
                ])) : g("", !0)
              ], 512)) : g("", !0)
            ])) : g("", !0),
            l(_, {
              name: "fade",
              appear: ""
            }, {
              default: c(() => [
                i.value === e(o).REVIEWS ? (s(), v("div", {
                  key: 0,
                  ref_key: "reviewsEl",
                  ref: x,
                  class: "flex flex-col h-full",
                  "data-testid": "reviewsList"
                }, [
                  l(ue, {
                    reviews: t.config.payload.reviews,
                    class: "flex-1 min-h-0"
                  }, null, 8, ["reviews"]),
                  b("div", De, [
                    l(e(V), {
                      type: "back",
                      onActionClick: a[4] || (a[4] = (r) => i.value = e(o).EXPANDED)
                    }),
                    l(S, {
                      data: t.config.payload.reviewAverages,
                      colors: {
                        darkText: e(E).colors.grey[900],
                        lightText: e(E).colors.grey[500]
                      },
                      orientation: "horizontal",
                      "show-info-btn": "",
                      tooltip: {
                        ...t.config.calculate.tooltip,
                        placement: "bottom"
                      },
                      class: "flex-1"
                    }, {
                      providersInfo: c(() => [
                        l(ge, {
                          data: t.config.calculate.providers,
                          direction: e(F)
                        }, null, 8, ["data", "direction"])
                      ]),
                      _: 1
                    }, 8, ["data", "colors", "tooltip"]),
                    l(e(V), {
                      type: "close",
                      onActionClick: a[5] || (a[5] = (r) => i.value = e(o).COLLAPSED)
                    })
                  ])
                ], 512)) : g("", !0)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["aria-label", "position", "onMouseenter"]));
  }
}), Re = /* @__PURE__ */ re(Ae, [["__scopeId", "data-v-6b7ebc20"]]);
export {
  Re as default
};
//# sourceMappingURL=FloatingDesktopReview.gt0bZfGm.js.map
